import React from 'react';
import { UnlockIcon, ArmchairIcon, HammerIcon } from 'lucide-react';
import { salesPageData } from '../data/salesPageData';
import { CategoriesBlock } from './solution/CategoriesBlock';
import { BenefitsBlock } from './solution/BenefitsBlock';
const STEPS = [{
  n: '01',
  icon: UnlockIcon,
  emoji: '🔓',
  title: 'Abrí la Bóveda',
  text: 'Ingresá desde celular, tablet o computadora.'
}, {
  n: '02',
  icon: ArmchairIcon,
  emoji: '🪑',
  title: 'Elegí qué querés fabricar',
  text: 'Explorá cientos de proyectos organizados por categorías.'
}, {
  n: '03',
  icon: HammerIcon,
  emoji: '🪚',
  title: 'Llevá la idea al taller',
  text: 'Consultá medidas, referencias y recursos antes de empezar.'
}];
export function SolutionSection() {
  return <section className="relative overflow-hidden bg-[#111111]" aria-labelledby="solution-title" data-id="element-337" data-mp="5w2vdk4kyg1e">
      <div className="blueprint-grid absolute inset-0 opacity-50" aria-hidden="true" data-id="element-338" data-mp="kstrnkiyjbms" />
      <div className="absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#D89A3D]/8 blur-[150px]" aria-hidden="true" data-id="element-339" data-mp="fv1ykn6ktjh0" />

      <div className="relative mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-340" data-mp="3b9fdp3sio4yu">
        <div className="mx-auto max-w-3xl text-center" data-id="element-341" data-mp="3bbjqkb8e8eb9">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#FF7A00]" data-id="element-342" data-mp="3faiwnz5v2h4a">
            🔓 Presentamos
          </p>
          <h2 id="solution-title" className="title-glow reveal mt-4 font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#F8F3EA] sm:text-5xl" data-id="element-343" data-mp="3p9hwqtck94fo">
            La Bóveda del Carpintero
            <span className="align-super text-base text-[#D89A3D]" data-id="element-344" data-mp="2u5jehuvc41m">™</span>
          </h2>
          <p className="mt-4 text-sm font-semibold uppercase tracking-[0.08em] text-[#D89A3D] sm:text-base" data-id="element-345" data-mp="6vh7uk20aj88">
            {salesPageData.tagline}
          </p>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl items-center gap-10 lg:grid-cols-2" data-id="element-346" data-mp="bsh4y5gvobn7">
          <img src={salesPageData.images.workshop} alt="Taller de carpintería real con maderas, planos impresos, metro y herramientas sobre el banco de trabajo" className="reveal w-full rounded-xl border border-[#EFEDE8]/10 object-cover shadow-[0_30px_60px_-30px_rgba(0,0,0,0.9)]" loading="lazy" width={1200} height={675} data-id="element-347" data-mp="gty5fzvg9w39" />
          <div className="reveal space-y-4 text-[15px] leading-relaxed text-[#EFEDE8]/75 sm:text-base" data-id="element-348" data-mp="2mofjnspi4ccg">
            <p data-id="element-349" data-mp="2vnarf9871uhv">
              Imaginá abrir una biblioteca y encontrar cientos de proyectos esperando
              que elijas uno.
            </p>
            <p className="text-[#EFEDE8]/55" data-id="element-350" data-mp="2rkxmuo56o2mo">
              No una carpeta perdida. No diez videos guardados. No cien capturas que
              nunca volvés a mirar.
            </p>
            <p className="font-display text-lg font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-351" data-mp="30m48fbmow3ms">
              Una verdadera Bóveda Digital de Carpintería.
            </p>
            <p data-id="element-352" data-mp="168mhden2son0">Un lugar donde entrás cada vez que quieras:</p>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5 text-sm text-[#EFEDE8]/80" data-id="element-353" data-mp="16ah3gwa32mso">
              {['fabricar,', 'aprender,', 'practicar,', 'buscar inspiración,', 'resolver un proyecto,', 'o encontrar una nueva idea.'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-354" data-mp="385wn9m3nsy8z">
                  <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#FF7A00]" data-id="element-355" data-mp="385myg1ucox4v" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="reveal mx-auto mt-14 max-w-3xl border-y border-[#EFEDE8]/10 py-10 text-center" data-id="element-356" data-mp="2z4f7y5y2t0lc">
          <p className="font-display text-lg font-extrabold uppercase leading-tight tracking-tight text-[#EFEDE8]/60 sm:text-2xl" data-id="element-357" data-mp="345w982kh2p2g">
            La pregunta deja de ser:
            <span className="mt-1 block text-[#EFEDE8]/80" data-id="element-358" data-mp="2u5c6swl7vein">“¿Qué puedo fabricar?”</span>
          </p>
          <p className="mt-5 font-display text-xl font-black uppercase leading-tight tracking-tight text-[#F8F3EA] sm:text-3xl" data-id="element-359" data-mp="nffqv2671f90">
            Y pasa a ser:
            <span className="mt-1 block text-[#FF7A00]" data-id="element-360" data-mp="scehhaqnf42g">“¿Con cuál empiezo?”</span>
          </p>
        </div>

        {/* Mecanismo de 3 pasos */}
        <div className="mt-14" data-id="element-361" data-mp="2khd59r87vkvs">
          <ol className="grid gap-4 md:grid-cols-3" data-id="element-362" data-mp="2kh3c5urvkxlv">
            {STEPS.map(step => <li key={step.n} className="reveal relative overflow-hidden rounded-xl border border-[#EFEDE8]/10 bg-[#181512] p-6 transition-all duration-200 hover:-translate-y-1 hover:border-[#FF7A00]/40" data-id="element-363" data-mp="2ffxk7z61hede">
                <span className="absolute right-4 top-3 font-numeric text-4xl font-bold text-[#EFEDE8]/[0.06]" aria-hidden="true" data-id="element-364" data-mp="25jugiovjh7oc">
                  {step.n}
                </span>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-[#D89A3D]/30 bg-[#111111]" data-id="element-365" data-mp="1wrslx785illz">
                  <step.icon className="h-5 w-5 text-[#FF7A00]" aria-hidden="true" data-id="element-366" data-mp="1rthbovdy2938" />
                </span>
                <h3 className="mt-4 font-display text-base font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-367" data-mp="1mrs27k6de3h9">
                  {step.emoji} {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#EFEDE8]/65" data-id="element-368" data-mp="17p0akaj1c1sl">
                  {step.text}
                </p>
              </li>)}
          </ol>
          <p className="reveal mt-8 text-center font-display text-base font-extrabold uppercase tracking-[0.08em] text-[#D89A3D] sm:text-xl" data-id="element-369" data-mp="1hn6c2r0xj5wx">
            Menos tiempo buscando. Más tiempo fabricando.
          </p>
        </div>
      </div>

      <CategoriesBlock data-id="element-370" data-mp="p0ljxocmqpsb" />
      <BenefitsBlock data-id="element-371" data-mp="owxsqvunqfgr" />
    </section>;
}